// Check when the recharge widget loads
waitForElm('.rc-widget').then((elm) => {
  elm.querySelectorAll('.rc-radio').forEach((el) => {
    el.addEventListener('click', () => {
      if (el.classList.contains('subscription-radio')) {
        getCurrentVariant();
      } else {
        resetQty();
      }
    });
  });
});

// Trigger event on load
window.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.dispatchEvent(new Event('check-quantity'));
  }, 300)
});

// Create event on the DOM so the event can be triggered across variant change and within this file
document.addEventListener('check-quantity', function () {
  if (window.location.search.indexOf('selling_plan') != -1) {
    getCurrentVariant();
  } else {
    resetQty();
  }
});

function getCurrentVariant() {
  let currentVariant = document.querySelector('.product .product-form input[name=id]').value;
  if (currentVariant != null) {
    getMinQty(currentVariant);
  }
}

function getMinQty(id) {
  let variantMinQty = document.querySelector(".variant-quantity[data-id='" + id + "']");
  if (variantMinQty) {
    if (variantMinQty.dataset.min != '') {
      setMinQty(variantMinQty.dataset.min);
    } else {
      resetQty()
    }
  }
}

function setMinQty(qty) {
  let qtyInput = document.querySelector('.product quantity-input input'),
    quantityStickyBar = document.querySelector('.js-quick-add-quantity'),
    minQty = document.getElementById('minimum-qty');

  if (minQty) {
    minQty.value = qty;
  }

  if (qtyInput) {
    qtyInput.value = qty;
    qtyInput.min = qty;
  }

  if (quantityStickyBar) {
    quantityStickyBar.value = qty;
  }

  if (qtyInput) {
    qtyInput.classList.add('quantity__input--disabled');
    qtyInput.setAttribute('readonly', true);
  }

}

function resetQty() {
  let qtyInput = document.querySelector('.product quantity-input input'),
    quantityStickyBar = document.querySelector('.js-quick-add-quantity'),
    minQty = document.getElementById('minimum-qty');

  if (minQty) {
    minQty.value = '';
  }

  if (qtyInput) {
    qtyInput.value = 1;
    qtyInput.min = 1;
  }

  if (quantityStickyBar) {
    quantityStickyBar.value = 1;
  }

  if (qtyInput) {
    qtyInput.classList.remove('quantity__input--disabled');
    qtyInput.removeAttribute('readonly');
  }
}